import { styled } from "@mui/material";
import { applyAlphaToColor } from "../../../../javascript-utils/color/index.js";
import { calendarNavigatorName } from "../classes.js";
const Button = styled("button", {
  name: calendarNavigatorName,
  slot: "Button",
  overridesResolver: (_, styles) => [styles.button]
})(({ theme, disabled }) => {
  const {
    palette: { primary, text, action }
  } = theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    padding: 0,
    margin: 0,
    outline: 0,
    borderWidth: 0,
    borderRadius: "4px",
    background: "transparent",
    color: action.active,
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? "default" : "pointer",
    transition: "background 0.2s ease, color 0.2s ease",
    "&:hover": {
      color: disabled ? text.disabled : text.primary,
      background: disabled ? "transparent" : applyAlphaToColor(primary.main, 0.1)
    }
  };
});
export {
  Button
};
//# sourceMappingURL=Button.js.map
